<template>
	<div style="padding:2px;">
		<div style="overflow-y: hidden;  width:1141px;margin:auto">
			<div
				style="font-size:18px;font-weight: 700;text-align: left; height:50px;line-height: 70px; border-bottom: 2px solid #ccc;">
				关于离离</div>
			<div style="height:80%;overflow-y: hidden;">
				<main class="container">
					<div style="margin-top: 10px">
						<p style="text-align: left; text-indent: 36px; line-height: 24px">
							离离钢铁平台是针对板材类钢铁进行产品技术咨询、个性设计定制、无忧加工配送的专业生产资料服务平台。平台创造性地采用集约化的生产管理模式，提供一体化加工配送服务，用智慧化的方式提高生产资料利用率，从而降低生产资料供应链能耗水平，达到降本增效绿色发展的目的。
						</p>
						<p style="text-align: left; text-indent: 36px; line-height: 24px">
							为保障产品品质与服务质量，平台供应的钢材板、卷均来自于攀钢、宝武青山、酒钢、包钢、马钢、柳钢、邯钢、沙钢等国内知名钢铁厂商，并由攀中伊红金属制品（重庆）有限公司负责所有线下服务。攀中伊红金属制品（重庆）有限责任公司是由攀钢集团国际经济贸易有限公司、台湾中钢集团中贸国际股份有限公司、日本伊藤忠丸红钢铁香港有限公司共同出资组建的合资公司，位于重庆市北部新区经开园，注册资本2.3亿元人民币。
						</p>
						<p style="text-align: left; text-indent: 36px; line-height: 24px">
							为更好地为平台会员提供服务，目前，离离钢铁线下服务范围设定在重庆辖区。
						</p>
						<p style="text-align: left; line-height: 24px" v-if="0">
							&emsp; 公司电话：023-65526431 &emsp; 平台负责人：雷建云
							&emsp;&emsp;&emsp;&emsp;&emsp;电话：15756316757
						</p>
						<p style="text-align: left; line-height: 24px">
							&emsp; 公司电话：023-65526431 &emsp; 平台负责人：陈莉
							&emsp;&emsp;&emsp;&emsp;&emsp;电话：18140031291
						</p>
					</div>
					<div class="main-content">
						<img src="../../assets/about/banner-BJ.png" alt="" />
					</div>
					<section>
						<div class="card">
							<div class="box">
								<div class="imgBx">
									<img src="../../assets/about/banner-1600_540.png" alt="" />
								</div>
								<div class="contentBx">
									<div>
										<h2>下载离离手机端</h2>
										<img src="../../assets/about/code.png" alt="" />
										<p>扫描二维码，可下载离离.APP。</p>
									</div>
								</div>
							</div>
						</div>
					</section>
					<div></div>
				</main>
			</div>
		</div>

		<div
			style="width:100%;margin-top: 10px; background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-top: 1px solid #ccc; margin-bottom: 2px;">
			2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
	};
</script>

<style lang="less" scoped>
	.container {
		margin: 0 auto;
		height: 800px;
	}

	main {
		.main-content {
			img {
				width: 100%;
			}
		}

		section {
			display: flex;
			position: relative;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			transform-style: preserve-3d;
			width: 100%;
			top: -500px;
			z-index: 20;
		}

		section .card {
			width: 420px;
			height: 420px;
			transform-style: preserve-3d;
			perspective: 1000px;
		}

		section .card .box {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transform-style: preserve-3d;
			transition: 1s ease;
		}

		section .card:hover .box {
			transform: rotateY(180deg);
		}

		section .card .box .imgBx {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}

		section .card .box .imgBx img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		section .card .box .contentBx {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: #333;
			backface-visibility: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
			transform-style: preserve-3d;
			transform: rotateY(180deg);
		}

		section .card .box .contentBx div {
			transform-style: preserve-3d;
			text-align: center;
			margin: auto;
			width: 80%;
			height: 80%;
			background: linear-gradient(45deg, #fe0061, #ffeb3b);
			transform: translateZ(100px);
		}

		section .contentBx img {
			width: 200px;
			height: 200px;
		}

		section .card .box .contentBx div h2 {
			color: #fff;
			font-size: 20px;
			letter-spacing: 1px;
		}

		section .card .box .contentBx div p {
			color: #fff;
			font-size: 16px;
		}
	}
</style>